import { folderAccessSettingsKeys } from 'app/pages/library/videos/videoList/components/folderAccessSettingsKeys';
import { FolderAccessSettings } from 'app/pages/library/videos/videoList/components/types';
import { EXPRESS_API } from 'configs/api/expressApi';
import { useQuery } from 'react-query';

const getFolderAccessSettings = async (
  folderId: number
): Promise<FolderAccessSettings[]> => {
  if (folderId <= 0) {
    return [] as FolderAccessSettings[];
  }

  const response = await EXPRESS_API.get(
    `/folders/${folderId}/access-settings`
  );
  return response.data;
};
export const useGetFolderAccessSettings = (folderId: number) => {
  return useQuery([folderAccessSettingsKeys.list(folderId)], () =>
    getFolderAccessSettings(folderId)
  );
};
